import { Box, Stack, Typography } from "@mui/material";

type LegendItemProps = {
  label: string;
  marker: "free" | "partial" | "occupied";
};

export function ColleagueFloorLegendItem({ label, marker }: Readonly<LegendItemProps>) {
  return (
    <Stack direction="row" spacing={0.75} alignItems="center">
      <Box
        aria-hidden
        sx={theme => {
          const freeColor = theme.palette.success.main;
          const occupiedColor = theme.palette.error.main;

          return {
            width: 14,
            height: 14,
            borderRadius: "50%",
            boxShadow: `0 0 0 1px ${theme.palette.divider}`,
            background:
              marker === "partial"
                ? `linear-gradient(90deg, ${freeColor} 0 50%, ${occupiedColor} 50% 100%)`
                : marker === "occupied"
                  ? occupiedColor
                  : freeColor
          };
        }}
      />
      <Typography variant="caption" sx={{ fontWeight: 600 }}>
        {label}
      </Typography>
    </Stack>
  );
}
